import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../UserContext"
import { useTranslation } from "react-i18next"
import axios from "axios"
//import { dispatchRefreshTokenEvent } from "./refreshTokenEvent"

const isDev = process.env.NODE_ENV !== "production"

export const IDENT_MGMT_API = isDev
  ? process.env.REACT_APP_IDENT_MGMT_API
  : "/IDENT_MGMT_API"
export const PLATFORM_API = isDev
  ? process.env.REACT_APP_PLATFORM_API
  : "/PLATFORM_API"
export const DATA_MGMT_API = isDev
  ? process.env.REACT_APP_DATA_MGMT_API
  : "/DATA_MGMT_API"
export const ASSET_MGMT_API = isDev
  ? process.env.REACT_APP_ASSET_MGMT_API
  : "/ASSET_MGMT_API"
export const LEASE_MGMT_API = isDev
  ? process.env.REACT_APP_LEASE_MGMT_API
  : "/LEASE_MGMT_API"
export const EGRESS_DATA_API = isDev
  ? process.env.REACT_APP_EGRESS_DATA_API
  : "/EGRESS_DATA_API"
export const BLDG_DATA_API = isDev
  ? process.env.REACT_APP_BLDG_DATA_API
  : "/BLDG_DATA_API"

export const SECURITY_API = process.env.REACT_APP_SECURITY_API


// ----- IDENT_MGMT API -----

// ### Forgot why the NoAuth setting looks exactly like the Auth one ###
// ### But the NoAuth does not have intercepters                     ###
export const axiosNoAuth_IDENT_MGMT_API = axios.create({
  baseURL: IDENT_MGMT_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const axiosAuth_IDENT_MGMT_API = axios.create({
  baseURL: IDENT_MGMT_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

/* ##### FUTURE EHHANCEMENT #####
// ----- SECURITY API -----

export const axiosAuth_SECURITY_API = axios.create({
  baseURL: SECURITY_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
##### FUTURE EHHANCEMENT ##### */

// ----- PLATFORM API -----

export const axiosAuth_PLATFORM_API = axios.create({
  baseURL: PLATFORM_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ----- DATA_MGMT API -----

export const axiosAuth_DATA_MGMT_API = axios.create({
  baseURL: DATA_MGMT_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ----- ASSET_MGMT API -----

export const axiosAuth_ASSET_MGMT_API = axios.create({
  baseURL: ASSET_MGMT_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ----- LEASE_MGMT API -----

export const axiosAuth_LEASE_MGMT_API = axios.create({
  baseURL: LEASE_MGMT_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ----- EGRESS_DATA API -----

export const axiosAuth_EGRESS_DATA_API = axios.create({
  baseURL: EGRESS_DATA_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ----- BLDG_DATA API -----

export const axiosAuth_BLDG_DATA_API = axios.create({
  baseURL: BLDG_DATA_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});



// This "fake" component is placed here so we can add an interceptor to detect access token expiration,
// and provide handling

const AxoisUtilComponent = ({ children }) => {
  const { user, setUser } = useContext(UserContext);
  const { i18n } = useTranslation(["common"]);
  const navigate = useNavigate();

  // ##### HACK. To retain the language setting. #####
  if (user) {
    sessionStorage.setItem("lng", i18n.language);
  }

  // ----- IDENT_MGMT API -----

  // ##### (Don't really understand) If placing the IDENT_MGMT's axiosAuth_IDENT_MGMT_API.interceptors.request.use()
  // ##### and axiosAuth_IDENT_MGMT_API.interceptors.response.use() inside useEffect(), like the other APIs, when
  // ##### refreshing the browser, it get into a strange state.

  // Interceptors for Axios RESPONSE
  const responseInterceptor_IDENT_MGMT_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_IDENT_MGMT_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_IDENT_MGMT_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }

  // Interceptor for Axios REQUESTS
  axiosAuth_IDENT_MGMT_API.interceptors.request.use(
    async (config) => {
      config.headers = {
        ...config.headers,
        Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
      }

      return config
    },
    (error) => Promise.reject(error)
  );

  //const interceptor = axiosAuth_IDENT_MGMT_API.interceptors.response.use(responseInterceptor_IDENT_MGMT_API, errorInterceptor_IDENT_MGMT_API);
  axiosAuth_IDENT_MGMT_API.interceptors.response.use(
    responseInterceptor_IDENT_MGMT_API,
    errorInterceptor_IDENT_MGMT_API
  );

  useEffect(() => {
    // ##### Original sample code ejects the interceptor, otherwise will keep adding more
    //       interceptors.  However, if we eject, the code stops working.  Needs to investigate.
    //return () => axiosAuth_IDENT_MGMT_API.interceptors.response.eject(interceptor);


/* ##### FUTURE EHHANCEMENT #####
    // ----- SECURITY API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_SECURITY_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    //const interceptor = axiosAuth_SECURITY_API.interceptors.response.use(responseInterceptor_SECURITY, errorInterceptor_SECURITY_API);
    axiosAuth_SECURITY_API.interceptors.response.use(
      responseInterceptor_SECURITY,
      errorInterceptor_SECURITY_API
    );

    // ##### Original sample code ejects the interceptor, otherwise will keep adding more
    //       interceptors.  However, if we eject, the code stops working.  Needs to investigate.
    //return () => axiosAuth_SECURITY_API.interceptors.response.eject(interceptor);
##### FUTURE EHHANCEMEN ##### */


    // ----- PLATFORM API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_PLATFORM_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    //const interceptor = axiosAuth_PLATFORM_API.interceptors.response.use(responseInterceptor_PLATFORM_API, errorInterceptor_PLATFORM_API);
    axiosAuth_PLATFORM_API.interceptors.response.use(
      responseInterceptor_PLATFORM_API,
      errorInterceptor_PLATFORM_API
    );

    // ----- DATA_MGMT API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_DATA_MGMT_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    //const interceptor = axiosAuth_DATA_MGMT_API.interceptors.response.use(responseInterceptor_DATA_MGMT_API, errorInterceptor_DATA_MGMT_API);
    axiosAuth_DATA_MGMT_API.interceptors.response.use(
      responseInterceptor_DATA_MGMT_API,
      errorInterceptor_DATA_MGMT_API
    );

    // ----- ASSET_MGMT API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_ASSET_MGMT_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    //const interceptor = axiosAuth_ASSET_MGMT_API.interceptors.response.use(responseInterceptor_ASSET_MGMT_API, errorInterceptor_ASSET_MGMT_API);
    axiosAuth_ASSET_MGMT_API.interceptors.response.use(
      responseInterceptor_ASSET_MGMT_API,
      errorInterceptor_ASSET_MGMT_API
    );

    // ----- LEASE_MGMT API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_LEASE_MGMT_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    axiosAuth_LEASE_MGMT_API.interceptors.response.use(
      responseInterceptor_LEASE_MGMT_API,
      errorInterceptor_LEASE_MGMT_API
    );

    // ----- EGRESS_DATA API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_EGRESS_DATA_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    axiosAuth_EGRESS_DATA_API.interceptors.response.use(
      responseInterceptor_EGRESS_DATA_API,
      errorInterceptor_EGRESS_DATA_API
    );

    // ----- BLDG_DATA API -----
    // Interceptor for Axios REQUESTS
    axiosAuth_BLDG_DATA_API.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
        }

        return config
      },
      (error) => Promise.reject(error)
    );

    axiosAuth_BLDG_DATA_API.interceptors.response.use(
      responseInterceptor_BLDG_DATA_API,
      errorInterceptor_BLDG_DATA_API
    );


    // ----- END -----

    // ##### Original sample code ejects the interceptor, otherwise will keep adding more
    //       interceptors.  However, if we eject, the code stops working.  Needs to investigate.
    //return () => axiosAuth_DATA_MGMT_API.interceptors.response.eject(interceptor);

    return

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


/* ##### FUTURE EHHANCEMENT #####
  // ----- SECURITY API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_SECURITY = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_SECURITY_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_SECURITY_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
##### FUTURE EHHANCEMENT ##### */

  // ----- PLATFORM API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_PLATFORM_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_PLATFORM_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_PLATFORM_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }

  // ----- DATA_MGMT API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_DATA_MGMT_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_DATA_MGMT_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_DATA_MGMT_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }

  // ----- ASSET_MGMT API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_ASSET_MGMT_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_ASSET_MGMT_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_ASSET_MGMT_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }

  // ----- LEASE_MGMT API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_LEASE_MGMT_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_LEASE_MGMT_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_LEASE_MGMT_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }

  // ----- EGRESS_DATA API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_EGRESS_DATA_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_EGRESS_DATA_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_EGRESS_DATA_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }


  // ----- BLDG_DATA API -----

  // Interceptors for Axios RESPONSES
  const responseInterceptor_BLDG_DATA_API = (response) => {
    return response
  }

  // Interceptors for Axios ERROR
  const errorInterceptor_BLDG_DATA_API = async (error) => {

    const originalRequest = error.config

    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response.data.msg === "ERR_Access_token_expired") {

        originalRequest._retry = true

        try {
          const res = await axiosAuth_IDENT_MGMT_API.get("/refresh-token");

          if (res.data.internalStatus === "SUCCESS") {
            sessionStorage.setItem("accessToken", res.data.accessToken);

            // Update the user context
            setUser({
              isAuth: true,
              userInfo: res.data.userInfo,
            });

            return axiosAuth_BLDG_DATA_API(originalRequest);
          } else {
            return Promise.reject(new Error("ERR_Std_500_Msg_IntnlErr"));
          }
        } catch (err1) {
          return Promise.reject(err1);
        }
      } else if (   (error.response.data.msg === "ERR_Refesh_token_expired")
                 || (error.response.data.msg === "ERR_User_not_logged_in")
                 || (error.response.data.msg === "ERR_Bad_Refesh_Token")) {
        setUser(null);
        sessionStorage.setItem("accessToken", "");

        // ##### The language is using a hack #####
        const language = sessionStorage.getItem("lng");
        i18n.changeLanguage(language);

        navigate("/Login/" + language);

        // Signal downstream handler to ignore this message, since cnotrol is redirected away
        // to login from the original logic already.
        return Promise.reject(new Error("IGNORE"));
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }


  // ----- END -----

  return children
}

//export default axiosAuth;
export { AxoisUtilComponent }
